export default {
    intro: `There are awkward or incorrect expressions mixed in.<br />Find the awkward parts and correct them!`,
    select: 'Select',
    fill: 'Correct the awkward parts to make them sound natural!',
    wrong: 'Oops, that\'s incorrect. Please try again.',
    find: 'Find the awkward part and tap it.',
    findCount: 'remaining.',
    table: {
        question: 'Question',
        answerRate: 'Accuracy',
        emptyMessage: 'No content available.',
    },
};
